import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useAddCategoryMutation } from "../../../features/api/categoryApi";
import { useAddSubjectMutation } from "../../../features/api/subjectApi";

const CreateSubject = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [title, setSubjectTitle] = useState("");

  const [addSubject] = useAddSubjectMutation();

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const newSubject = { title };
      const response = await addSubject(newSubject);

      if (response?.data) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Subject create success...!!!");
      } else if (response?.error) {
        setIsOpen(false);
        toast.error("Create Subject failed...!!!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white rounded-sm bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Subject
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card overflow-auto mt-4 ">
              <div className="card-body">
                <form
                  onSubmit={handleAdd}
                  className="flex flex-col items-start font-extralight p-4 w-full"
                  style={{ lineHeight: "30px" }}
                >
                  <label className="font-bold">Subject Title:</label>
                  <input
                    type="text"
                    onChange={(e) => setSubjectTitle(e.target.value)}
                    className="border pl-1 w-full bg-slate-50 focus:outline-none rounded"
                  />
                  <input
                    type="submit"
                    value="Submit"
                    className="bg-blue-500 text-white font-bold mt-4 px-4 rounded block m-auto cursor-pointer"
                  />
                </form>
                {/* <button
                  onClick={handleAdd}
                  className="bg-blue-500 text-white font-bold mt-4 px-4 rounded block m-auto"
                >
                  Submit
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateSubject;
